<template>
  <div class="reaction_body">
    <div class="tabs">
      <div
        class="tab"
        @click="selectedReaction = tab.title"
        :class="selectedReaction == tab.title ? 'active' : ''"
        v-for="(tab, index) in reactions"
        :key="index"
      >
        <figure class="reaction" v-if="tab.icon">
          <img :src="getImageUrl(tab.icon)" />
        </figure>
        <p>
          <span v-if="!tab.icon">{{ tab.title }}</span> ({{ tab.count }})
        </p>
      </div>
    </div>
    <div class="tabs_view" id="pr_reactions">
      <p class="error_txt" v-if="!filterReactions.length">No Reaction Yet</p>
      <div class="item" v-for="item in filterReactions" :key="item._id">
        <ProfileAvatarComponent
          :badges="false"
          :border="true"
          class="small mr-10"
        />
        <h6>{{ item.userFullName }}</h6>
        <figure class="reaction">
          <img
            v-if="item.reactionType == 'like'"
            src="../../../../../assets/images/likeicon01.png"
          />
          <img
            v-if="item.reactionType == 'heart'"
            src="../../../../../assets/images/likeicon02.png"
          />
          <img
            v-if="item.reactionType == 'appreciated'"
            src="../../../../../assets/images/likeicon03.png"
          />
          <img
            v-if="item.reactionType == 'kiss'"
            src="../../../../../assets/images/likeicon04.png"
          />
        </figure>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Reactions } from "@/helpers/enum";
import { ReactionType } from "../../models/likepost.model";
import utilService from "@/services/util.service";
import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import { usePostReaction } from "../../composables/postReaction.composable";
import ProfileAvatarComponent from "@/components/ProfileAvatarComponent.vue";

export default defineComponent({
  props: ["sourceId", "sourceType"],
  components: {
    ProfileAvatarComponent,
  },
  setup(props) {
    const {
      handlePostreactions,
      postReactions,
      handleReactionsFigure,
      reactions,
      selectedReaction,
      filterReactions,
      stopFetching,
    } = usePostReaction();

    const tabs = ref<any[]>([
      {
        title: "All",
        count: 0,
      },
      {
        title: ReactionType.Like,
        icon: Reactions.like,
        count: 22,
      },
      {
        title: ReactionType.Heart,
        icon: Reactions.love,
        count: 20,
      },
      {
        title: ReactionType.Appreciated,
        icon: Reactions.blessed,
        count: 10,
      },
      {
        title: ReactionType.Kiss,
        icon: Reactions.smooch,
        count: 2,
      },
    ]);

    const getImageUrl = (url: string, directory: string | null) =>
      utilService.getImageUrl(url, directory);

    onMounted(() => {
      handlePostreactions(props.sourceId);
    });

    onUnmounted(() => {
      stopFetching();
    });

    return {
      tabs,
      selectedReaction,
      getImageUrl,
      handlePostreactions,
      postReactions,
      reactions,
      filterReactions,
      stopFetching,
    };
  },
});
</script>

<style lang="scss">
.postReactionModal {
  .modal-content {
    min-width: 480px;
    min-height: 500px;
    .modal_header {
      position: relative;
      user-select: none;
      .icon_back {
        position: absolute;
        left: 10px;
        background: #ffffff80;
        color: #181326;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        cursor: pointer;
      }
    }
  }
}
</style>
